import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import './WhyChooseAyonk.css';

const items_ar = [
  'شركة رائدة في مجال الإنشاءات والتصميم الداخلي',
  'فريق متخصص من المهندسين والمصممين المحترفين',
  'سجل حافل بالمشاريع الناجحة لأكثر من 15 عاماً',
  'شراكات استراتيجية مع أفضل الموردين والمقاولين',
  'تقنيات بناء حديثة ومستدامة',
  'خدمة عملاء متميزة على مدار الساعة',
];

const items_en = [
  'Leading company in construction and interior design',
  'Specialized team of professional engineers and designers',
  'A track record of successful projects for over 15 years',
  'Strategic partnerships with the best suppliers and contractors',
  'Modern and sustainable construction techniques',
  'Exemplary 24/7 customer service',
];

export function WhyChooseAyonk() {
  const { t, language } = useLanguage();
  const isRtl = language === 'ar';
  const items = isRtl ? items_ar : items_en;
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.wca-item').forEach((el, i) => {
              setTimeout(() => el.classList.add('wca-item--visible'), i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="wca-section" dir={isRtl ? 'rtl' : 'ltr'} ref={sectionRef}>
      <div className="wca-top-bar" />

      {/* Decorative orbs */}
      <div className="wca-orb wca-orb--gold" />
      <div className="wca-orb wca-orb--red" />

      <div className="wca-container">

        {/* Header */}
        <div className="wca-header">
          <div className="wca-label-row">
            <span className="wca-label-line" />
            <span className="wca-label-text">
              {isRtl ? 'لماذا تختار أيونك' : 'Why Choose Ayonk'}
            </span>
            <span className="wca-label-line" />
          </div>
          <h2 className="wca-title">{t('whyChooseAyonk.title')}</h2>
          <p className="wca-subtitle">{t('whyChooseAyonk.subtitle')}</p>
        </div>

        {/* Items */}
        <div className="wca-grid">
          {items.map((item, idx) => (
            <div key={idx} className="wca-item">
              <div className="wca-number-glow" />
              <div className="wca-item-number">
                {String(idx + 1).padStart(2, '0')}
              </div>
              <div className="wca-item-divider" />
              <p className="wca-item-text">{item}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="wca-cta">
          <div className="wca-cta-left">
            <div className="wca-cta-line" />
            <div>
              <h3 className="wca-cta-title">{t('whyChooseAyonk.ctaTitle')}</h3>
              <p className="wca-cta-sub">{t('whyChooseAyonk.ctaSub')}</p>
            </div>
          </div>
          <Link to="/contact" className="wca-cta-btn">
            <span className="wca-btn-text">{t('whyChooseAyonk.ctaBtn')}</span>
            <span className="wca-btn-arrow">{isRtl ? '←' : '→'}</span>
          </Link>
        </div>

      </div>
    </section>
  );
}
